import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BoardView = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M21 4.5H13.5V17C13.5 17.5523 13.9477 18 14.5 18L20 18C20.5523 18 21 17.5523 21 17V4.5Z"
        fill={color}
        fillOpacity="0.05"
      />
      <path
        d="M10.5 4.5H3V20C3 20.5523 3.44772 21 4 21L9.5 21C10.0523 21 10.5 20.5523 10.5 20V4.5Z"
        fill={color}
        fillOpacity="0.05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 4H10.25V20.75H3.25V4ZM2.25 4C2.25 3.44772 2.69772 3 3.25 3H10.25C10.8023 3 11.25 3.44772 11.25 4V20.75C11.25 21.3023 10.8023 21.75 10.25 21.75H3.25C2.69772 21.75 2.25 21.3023 2.25 20.75V4ZM13.75 4H20.75V17H13.75V4ZM12.75 4C12.75 3.44772 13.1977 3 13.75 3H20.75C21.3023 3 21.75 3.44772 21.75 4V17C21.75 17.5523 21.3023 18 20.75 18H13.75C13.1977 18 12.75 17.5523 12.75 17V4Z"
        fill={color}
      />
    </svg>
  )
})

export default BoardView
